import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Layout/Navbar";
import Footer from "./components/Layout/Footer";
import BridgePage from "./pages/bridge";
import HistoryPage from "./pages/history";
import StatusPage from "./pages/status";
import HomePage from "./pages/index";
import "./index.css";

function App() {
  // When the app is served from a sub-path (e.g. testnet.dingocoin.com/app),
  // CRA sets PUBLIC_URL and we feed it to the router as basename. Empty for
  // root-served deployments, so production behaviour is unchanged.
  const basename = process.env.PUBLIC_URL || undefined;
  return (
    <BrowserRouter basename={basename}>
      <div className="flex min-h-screen flex-col bg-dark-800">
        <Navbar />
        <main className="flex-1 w-full">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/bridge" element={<BridgePage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/status" element={<StatusPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App; 